import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Client } from '../client';
import { User } from '../user';
import { Contact } from '../contact';
import { Address } from '../address';
import { ClientCategory } from '../clientCategory';
import { AuthResponse } from '../auth-response';
import { Brregcompany } from '../brregcompany';
import { ClientsService } from '../clients.service';
import { BrregService } from '../brreg.service';
import { UsersService } from '../users.service';
import { getObjIndex } from '../functions';
import { Location } from '@angular/common';
import { capitalizeWords } from '../functions';
import { UserAuthService } from '../user-auth.service';
import * as moment from 'moment'; // https://momentjs.com/
moment.locale('nb');

@Component({
	selector: 'app-client',
	templateUrl: './client.component.html',
	styleUrls: ['./client.component.css'],
	providers: [ ClientsService, BrregService, UsersService ],
})
export class ClientComponent implements OnInit {
	client: Client = <Client>{};
	clientID: number; // always 0 when creating new client
	users: User[];
	selectedUsers: User[];
	newContact: Contact = <Contact>{};
	deletedContacts: Contact[] = [];
	newAddress: Address = <Address>{};
	brregSuccess: boolean;
	deletedAddresses: Address[] = [];
	action: string; // possible values: create, edit
	errorMessage: string;
	currentUser: AuthResponse;

	// client categories (in db, so TODO is fetching them dynamically)
	clientCategories: ClientCategory[] = [
		{ id: 1, name: 'Ikke interessert'},
		{ id: 2, name: 'Lead'},
		{ id: 3, name: 'Kunde'},
		{ id: 4, name: 'Prospect'},
		{ id: 5, name: 'Hot Prospect'},
		{ id: 6, name: 'Tapt kunde'},
		{ id: 7, name: 'Forretningsforbindelse'},
		{ id: 8, name: 'Konkurrent'},
		{ id: 9, name: 'Samarbeidspartner'},
		{ id: 10, name: 'Leverandør'},
	];
	selectedClientCategory: number;

	isLoading = false;
	isResponse: string;
	isResponseClass: string;

	addNewAddress: string;

	breadcrumbs = [];

	constructor(
		private clientsService: ClientsService,
		private brregService: BrregService,
		private usersService: UsersService,
		private userAuthService: UserAuthService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private location: Location,
	) { }

	goBack()
	{
		this.location.back(); // <-- go back to previous location (route wise)
	}

	getClient(id: number)
	{
		this.clientsService.getClient(id)
			.subscribe(
				(client: Client) => {

					this.client = client;
					console.log(this.client);

					if ( !client.category ) // necessary for the select to be defaulted
					{
						this.client.category = 0;
					}

				},
				error => {

					if ( this.action != 'create' )
					{
						this.errorMessage = 'Couldn\'t retrieve client (maybe the client with this ID doesn\'t exist)';
					}

					// if creating new user, the client shall have the current user preset as owner; pt.1
					if ( this.action == 'create' ) {
						console.log( this.currentUser );
						this.client['users'] = [
							{
								id: this.currentUser['user_id'],
								username: this.currentUser['name'],
								email: '',
								password: '',
							}
						];
					}

				}
			);
	}

	createClient( name: string, orgNr: string, invoiceEmail: string = null, invoiceByEmail: number = 0, 
										clientUrl: string = null, clientPhone: string = null, clientEmail: string = null,
										clientCategory: number = null, international: boolean = false, nextFollowUpDate: string = null, customerSince: string = null )
	{

		this.isLoading = true;

		if ( typeof invoiceByEmail == 'boolean' ) {
			if ( invoiceByEmail == false ) { // convert false to 0 (seems like true is converted to 1 automatically, which is good, as it's what the API wants)
				invoiceByEmail = 0;
			}
		}

		if (clientCategory == 0) { clientCategory = null; }

		let clientObj = {
			'name': name,
			'org_nr': orgNr.replace(/ /g, ''), // remove (potential) spaces
			'email_invoice': invoiceByEmail,
			'invoice_email': invoiceEmail,
			'next_follow_up': nextFollowUpDate,
			'customer_since': customerSince,
			'url': clientUrl,
			'phone': clientPhone,
			'email': clientEmail,
			'category': clientCategory,
			'international': international,
		}
		console.log( clientObj );

		this.clientsService.createClient( clientObj )
			.finally( // triggers independently of success or error
				() => {
					this.isLoading = false;
				}
			)
			.subscribe( 

				(client: Client) => {

					// get the client ID for attaching other relations
					this.client['id'] = client.id;
					// if creating new user, the client shall have the current user preset as owner; pt.2
					this.selectedUsers = this.client['users'];

					// set success by default and give notice
					this.isResponseClass = 'success';
					this.isResponse = '<p class=\'success\'>Bedriften ble opprettet!</p> <p>';

					// run through and create addresses, customer contacts and user relations after client is saved
					this.clientUserUpdateAllRelations();
					this.clientContactUpdateAllRelations();
					this.clientAddressesUpdateAllRelations();

					setTimeout(() => {

						// redirect accordingly
						if ( this.isResponseClass == 'partial' ) {
							this.isResponse += '</p> <br> <p class=\'success\'> <i>-- du blir nå sendt til bedriftssiden --</i> </p>';
								setTimeout(() => {
							 		this.router.navigate([ 'client' + '/' + this.client['id'] ]);
								}, 2500);
						} else {
							this.isResponse += '</p> <br> <p class=\'success\'> <i>-- du blir nå sendt til oversikten --</i> </p>';
							setTimeout(() => {
						 		this.router.navigate([ 'clients' + '/' + 'all', {id: this.client['id']} ]);
							}, 2000);
						}

					}, 500);

				},

				err => {

					this.isResponse = '<p> Det oppstod en feil! Vennligst prøv igjen. </p>';
					this.isResponseClass = 'error';

					setTimeout(() => {
					    this.isResponse = '';
					}, 3000);
				},

			);
	}
	updateClient( id: number, name: string, orgNr: string, invoiceEmail: string = null, invoiceByEmail: any = false,
										clientUrl: string = null, clientPhone: string = null, clientEmail: string = null, 
										clientCategory: number = null, nextFollowUpDate: string = null )
	{

		this.isLoading = true;

		// API expects 0/1, so we convert
		if ( [false, 'false', 0, '0'].indexOf(invoiceByEmail) != -1 ) {
			invoiceByEmail = 0;
		} else {
			invoiceByEmail = 1;
		}

		if (clientCategory == 0) { clientCategory = null; }

		let clientObj = {
			'name': name,
			'org_nr': orgNr.replace(/ /g, ''), // remove (potential) spaces
			'email_invoice': invoiceByEmail,
			'invoice_email': invoiceEmail,
			'next_follow_up': nextFollowUpDate,
			'url': clientUrl,
			'phone': clientPhone,
			'email': clientEmail,
			'category': clientCategory,
		}

		this.clientsService.updateClient( id, clientObj )
			.finally( // triggers independently of success or error
				() => {
					this.isLoading = false;
				}
			)
			.subscribe( 

				(client: Client) => {

					// set success by default and give notice
					this.isResponseClass = 'success';
					this.isResponse = '<p class=\'success\'>Bedriften ble oppdatert!</p> <p>';

					this.clientUserUpdateAllRelations();
					this.clientContactUpdateAllRelations();
					this.clientAddressesUpdateAllRelations();

					setTimeout(() => {

						// redirect accordingly
						if ( this.isResponseClass == 'partial' ) {
							this.isResponse += '</p> <br> <p class=\'success\'> <i>-- du blir nå sendt til siden du kom fra --</i> </p>';
								setTimeout(() => {
							 		this.goBack();
								}, 2500);
						} else {
							this.isResponse += '</p> <br> <p class=\'success\'> <i>-- du blir nå sendt til siden du kom fra --</i> </p>';
							setTimeout(() => {
						 		this.goBack();
							}, 2000);
						}

					}, 500);

				},

				err => {

					this.isResponse = '<p> Det oppstod en feil! Vennligst prøv igjen. </p>';
					this.isResponseClass = 'error';

					setTimeout(() => {
					    this.isResponse = '';
					}, 3000);

				},
			);
	}
	getClientInfo( orgNr: string ) // retrieve info from brønnoysundregisteret about current org nr
	{
		// 913451813 = Fjaerestad Web
		// 994932691 = Semway Norge AS

		let orgNrStripped = orgNr.replace(/ /g, '');
		let orgNrNum = parseInt( orgNrStripped, 10 ); // str to number

		if ( !isNaN(orgNrNum) && orgNrStripped.length == 9 ) { // only proceed if orgnr is an actual number and consists of 9 numbers (which org numbers should)

			this.brregService.getCompany(orgNrNum)
				.subscribe(
					(company: Brregcompany) => {
						
						this.client.name = capitalizeWords(company.navn.toLowerCase());
						this.client.url = company.hjemmeside;

						this.newAddress = {
							name: capitalizeWords(company.navn.toLowerCase()),
							postal_city: capitalizeWords(company.forretningsadresse['poststed'].toLowerCase()),
							postal_code: company.forretningsadresse['postnummer'],
							street: company.forretningsadresse['adresse'],
						};
						
						this.addNewAddress = 'isActive';

						this.brregSuccess = true;
					},
					error => {

						this.client.name = '';
						this.brregSuccess = false;

						// if ( this.action != 'create' ) {
						// 	this.errorMessage = 'Couldn\'t retrieve client (maybe the client with this ID doesn\'t exist)';
						// }
					}
				);

		} else {
			
			this.client.name = '';
			this.brregSuccess = false;

		}
	}
	deleteClient( id: number )
	{
		this.clientsService.deleteClient( id )
			.subscribe(response => {
				// console.log(response);
			});
	}

	/**
	 * change a property value of this class or nested properties of properties (e.g. this['client']['name']).
	 * supports infinite levels of nesting
	 * @param array, required - properties ( e.g. if changing this['client']['name'], pass ['client', 'name'] )
	 * @param any, required - value ( value to change to )
	 */
	// changeValue( properties = [], value: any ) {
	// 	var prevObj = this;

	// 	function matchProperty ( prop, prevObj ) {
	// 		for ( var property in prevObj ) {
	// 			if ( property == prop ) {
	// 				return prevObj[property];
	// 			}
	// 		}
	// 	}

	// 	for (var i = 0; i < properties.length - 1; i++) {
	// 		prevObj = matchProperty(properties[i], prevObj);
	// 	}

	// 	prevObj[properties[properties.length - 1]] = value;

	// }

	getUsers()
	{
		this.usersService.getUsers()
			.subscribe(
				(Users: User[]) => {
					this.users = Users;
				},
				error => {
					if ( this.action != 'create' ) {
						this.errorMessage = 'Couldn\'t retrieve Users';
					}
				}
			);
	}

	clientUserCouple( clientID: number, userID: number )
	{

		if ( clientID && userID ) {

			this.isLoading = true;

			this.usersService.clientUserCouple( clientID, userID )
				.finally( // triggers independently of success or error
					() => {
						this.isLoading = false;
					}
				)
				.subscribe(
					(res: any ) => {

					},
					err => {
						// parse error message
						var obj = JSON.parse(err._body);

						// do not display error if user already attached
						if ( obj[0].message.indexOf('of Customer ID, User ID and Ended At has already been taken') >= 0 )
						{
							console.log('user already attached');
						} else {
							this.isResponseClass = 'partial';
							this.isResponse += 'Bruker ble ikke tilknyttet. <br>';
						}
						
					}
				);

		}

	}

	// clientUserEditRelation( couplingID: number, endedBy: number, endedAt: string ) {
	clientUserEditRelation( couplingID: number, endedBy: number )
	{

		this.isLoading = true;

		this.usersService.clientUserEditRelation( couplingID, endedBy )
			.finally( // triggers independently of success or error
				() => {
					this.isLoading = false;
				}
			)
			.subscribe(
				(res: {} ) => {
				},
				err => {

				}
			);

	}

	clientUserUpdateAllRelations()
	{

		// remove deleted user relations
		if ( ! Array.isArray( this.client['user_relations'] ) ) {
			this.client['user_relations'] = [];
		}

		let deletedUserRelations = this.client['user_relations'].filter( // seems to work
			relation => getObjIndex(relation.user_id, this.selectedUsers) === -1
		);
		for (var i = 0; i < deletedUserRelations.length; ++i) {
			let relationID = deletedUserRelations[i]['id'];
			this.clientUserEditRelation( relationID, this.currentUser.user_id );
		}

		if ( ! Array.isArray( this.selectedUsers ) ) {
			this.selectedUsers = [];
		}

		// add new user relations
		let addedUserRelations = this.selectedUsers.filter( // seems to work
			// user => getObjIndex(user.id, this.client['user_relations'], 'user_id') === -1 || this.client['user_relations'][ getObjIndex(user.id, this.client['user_relations'], 'user_id') ]['ended_at'] != '0000-00-00 00:00:0000'
			user => {
				let objIndex = getObjIndex(user.id, this.client['user_relations'], 'user_id');
				objIndex === -1 || this.client['user_relations'][objIndex]['ended_at'] != '0000-00-00 00:00:0000';
				return user;
			}
		);
		for (var i = 0; i < addedUserRelations.length; ++i) {
			let userID = addedUserRelations[i]['id'];
			this.clientUserCouple(this.client.id, userID);
		}

	}

	clientContactUpdateAllRelations()
	{

		if ( ! Array.isArray( this.client['contacts'] ) ) {
			this.client['contacts'] = [];
		}

		for (var i = 0; i < this.client['contacts'].length; ++i) {
			let contact = this.client['contacts'][i];
			if ( ! contact['id'] ) {
				this.createClientContact( this.client['id'], contact.name, contact.title, contact.email, contact.phone, contact.phone_extra, contact.comment ); // good
			} else {
				this.updateClientContact( contact['id'], contact.name, contact.title, contact.email, contact.phone, contact.phone_extra, contact.comment );
			}
		}

		for ( var i = 0; i < this.deletedContacts.length; ++i )
		{
			let contact = this.deletedContacts[i];
			if (contact['id']) { // only delete those that have been saved in db (database) earlier
				this.deleteClientContact( contact['id'], this.currentUser.user_id, moment().format('YYYY-MM-DD hh:mm:ss') );
			}
		}

	}

	clientAddressesUpdateAllRelations()
	{

		if ( ! Array.isArray( this.client['addresses'] ) ) {
			this.client['addresses'] = [];
		}

		for (var i = 0; i < this.client['addresses'].length; ++i) {
			let address = this.client['addresses'][i];
			if ( ! address['id'] ) {
				this.createClientAddress( this.client['id'], address.name, address.street, address.postal_code, address.postal_city );
			} else {
				this.updateClientAddress( address['id'], address.name, address.street, address.postal_code, address.postal_city );
			}
		}

		for ( var i = 0; i < this.deletedAddresses.length; ++i )
		{

			let address = this.deletedAddresses[i];
			if ( address['id'] ) { // only delete those that have been saved in db (database) earlier
				this.deleteClientAddress( address['id'], this.currentUser.user_id, moment().format('YYYY-MM-DD hh:mm:ss') );
			}

		}

	}

	// adds to array
	addClientContact()
	{

		if ( this.client['contacts'] )
		{
			this.client['contacts'].push( this.newContact );
			this.newContact = <Contact>{};
		}

	}

	// removes from array
	removeClientContact(index)
	{

		this.deletedContacts.push( this.client['contacts'][index] );
		this.client['contacts'].splice( index, 1 );

	}

	// creates contact (in DB)
	createClientContact( customerID: number, name: string, title?: string, email?: string, phone?: string, phoneExtra?: string, comment?: string, directly: boolean = false )
	{

		if ( !customerID || !name ) {
			if ( directly ) {
				this.isResponse = 'Du må fylle inn navn på Kontaktperson! <br>';
				this.isResponseClass = 'error';
				setTimeout(() => {
				    this.isResponse = '';
				}, 2000);
			} else {
				this.isResponseClass = 'partial';
				this.isResponse += 'Kontaktperson ble ikke tilknyttet. <br>';
			}
			return false;
		}

		this.clientsService.createClientContact( customerID, name, title, email, phone, phoneExtra, comment )
			.subscribe(
				(res: any) => {
					//console.log(res);

					if ( directly ) {
						console.log( res );
						this.newContact['id'] = res['id'];
						this.client['contacts'].push( this.newContact );
						this.newContact = <Contact>{};

						this.isResponse += 'Kontaktperson ble lagret! <br>';
						this.isResponseClass = 'success';
						setTimeout(() => {
						    this.isResponse = '';
						}, 1500);
					}
					
				},
				error => {
					//console.log(error);
					if ( directly ) {
						this.isResponse += 'FEIL: Kontaktperson ble ikke lagret! <br>';
						this.isResponseClass = 'error';
						setTimeout(() => {
						    this.isResponse = '';
						}, 2500);
					} else {
						this.isResponseClass = 'partial';
						this.isResponse += 'Kontaktperson ble ikke tilknyttet. <br>';
					}
				},
			);

	}

	// updates contact (in DB)
	updateClientContact( contactID: number, name?: string, title?: string, email?: string, phone?: string, phoneExtra?: string, comment?: string )
	{

		this.clientsService.updateClientContact( contactID, name, title, email, phone, phoneExtra, comment )
			.subscribe(
				(res: any) => {
					//console.log(res);
				},
				err => {
					//console.log(err);
				}
			);

	}

	// deletes contact (in DB - basically sets ended_by and ended_at values)
	deleteClientContact( contactID: number, endedBy: number, endedAt: string, directly: boolean = false )
	{

		this.clientsService.deleteClientContact( contactID, endedBy, endedAt )
			.subscribe(
				(res: any) => {
					//console.log(res);
					if ( directly ) {
						this.isResponse += 'Kontaktperson ble slettet! <br>';
						this.isResponseClass = 'success';
						setTimeout(() => {
						    this.isResponse = '';
						}, 1500);
					}
				},
				error => {
					//console.log(error);
					if ( directly ) {
						this.isResponse += 'FEIL: Kontaktperson ble ikke slettet! <br>';
						this.isResponseClass = 'error';
						setTimeout(() => {
						    this.isResponse = '';
						}, 2500);
					}
				},
			);

	}

	// adds to array
	addClientAddress()
	{

		if ( ! Array.isArray(this.client['addresses']) ) { // convert to array if necessary, or else push() will throw error
			this.client['addresses'] = [];
		}
		this.newAddress['name'] = this.client.name;
		this.client['addresses'].push( this.newAddress );
		this.newAddress = <Address>{};

	}

	// removes from array
	removeClientAddress(index)
	{
		
		this.deletedAddresses.push( this.client['addresses'][index] );
		this.client['addresses'].splice( index, 1 );

	}

	// creates address (in DB)
	createClientAddress( customerID: number, name: string, street: string, postalCode: string, postalCity: string, directly: boolean = false )
	{

		if ( !customerID || !street || !postalCode || !postalCity ) {
			if ( directly ) {
				this.isResponse = 'Du må fylle inn gatenavn, postnummer og poststed på adresse! <br>';
				this.isResponseClass = 'error';
				setTimeout(() => {
				    this.isResponse = '';
				}, 2500);
			} else {
				this.isResponseClass = 'partial';
				this.isResponse += 'Adresse ble ikke tilknyttet. <br>';
			}
			return false;
		}

		this.clientsService.createClientAddress( customerID, name, street, postalCode, postalCity )
			.subscribe(
				(res: any) => {
					//console.log(res);
					if ( directly ) {
						this.newAddress['id'] = res['id'];
						this.client['addresses'].push( this.newAddress );
						this.newAddress = <Address>{};

						this.isResponse = 'Adresse ble lagret! <br>';
						this.isResponseClass = 'success';
						setTimeout(() => {
						    this.isResponse = '';
						}, 1500);
					}
				},
				error => {
					//console.log(error);
					if ( directly ) {
						this.isResponse = 'FEIL: Adresse ble ikke lagret! <br>';
						this.isResponseClass = 'error';
						setTimeout(() => {
						    this.isResponse = '';
						}, 2500);
					} else {
						this.isResponseClass = 'partial';
						this.isResponse += 'Adresse ble ikke tilknyttet. <br>';
					}
				},
			);

	}

	// updates address (in DB)
	updateClientAddress( addressID: number, name?: string, street?: string, postalCode?: string, postalCity?: string )
	{

		this.clientsService.updateClientAddress( addressID, name, street, postalCode, postalCity )
			.subscribe(
				(res: any) => {
					// console.log(res);
				},
				err => {
					//console.log(err);
				}
			);

	}

	// deletes address (in DB - basically sets ended_by and ended_at values)
	deleteClientAddress( addressID: number, endedBy: number, endedAt: string, directly: boolean = false )
	{

		this.clientsService.deleteClientAddress( addressID, endedBy, endedAt )
			.subscribe(
				(res: any) => {
					if ( directly ) {
						this.isResponse = 'Adresse ble slettet! <br>';
						this.isResponseClass = 'success';
						setTimeout(() => {
						    this.isResponse = '';
						}, 2500);
					}
				},
				(error: any) => {
					if ( directly ) {
						this.isResponse = 'FEIL: Adresse ble ikke slettet! <br>';
						this.isResponseClass = 'error';
						setTimeout(() => {
						    this.isResponse = '';
						}, 2500);
					}
				},
			);

	}

	// setSelectedUser( index: number ) {
	// 	this.selectedUser = this.users[index];
	// 	console.log(this.selectedUser);
	// }

	setUsers( users: any )
	{
		this.selectedUsers = users;
	}


	getCurrentUser()
	{
    	this.currentUser = this.userAuthService.getCurrentUser();
    }

	ngOnInit()
	{
		// this.createClient('Testbedrift3', '789'); // works
		// this.updateClient(1, {name: 'Lampemagasinet AS'}); // works
		this.activatedRoute.params
							.subscribe( (params: {}) => {
								this.clientID = +params['id']; // the + is a hack to convert string to number
								this.action = params['action'];

								if ( isNaN(this.clientID) ) {
									this.errorMessage = 'Error: The client ID route param must be a number';
								} else {
									this.getClient( this.clientID );
									this.getUsers();
								}

							});

		this.getCurrentUser();
	}
}



// WEBPACK FOOTER //
// ./src/app/client/client.component.ts